var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationFillIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 34.28C18.63 34.2655 19.2345 34.0287 19.7067 33.6114C20.1788 33.1942 20.4882 32.6234 20.5801 32H15.3201C15.4145 32.6403 15.7384 33.2245 16.2314 33.6439C16.7244 34.0633 17.3529 34.2894 18.0001 34.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.85 28.13L32.51 27.83C31.5455 26.9706 30.7012 25.9851 30 24.9C29.2343 23.4026 28.7753 21.7673 28.65 20.09V15.15C28.646 14.55 28.5925 13.9513 28.49 13.36C26.7962 13.0119 25.2746 12.089 24.1831 10.7478C23.0915 9.40657 22.4969 7.72932 22.5 6.00002V5.37002C21.456 4.85621 20.3342 4.51833 19.18 4.37002V3.11002C19.18 2.75596 19.0394 2.4164 18.789 2.16604C18.5387 1.91568 18.1991 1.77502 17.845 1.77502C17.491 1.77502 17.1514 1.91568 16.9011 2.16604C16.6507 2.4164 16.51 2.75596 16.51 3.11002V4.42002C13.9258 4.78458 11.5606 6.07177 9.85127 8.04396C8.14192 10.0161 7.20378 12.5402 7.21005 15.15V20.09C7.0848 21.7673 6.62583 23.4026 5.86005 24.9C5.17093 25.9824 4.34024 26.9678 3.39005 27.83L3.05005 28.13V30.95H32.85V28.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 11C32.7614 11 35 8.76142 35 6C35 3.23858 32.7614 1 30 1C27.2386 1 25 3.23858 25 6C25 8.76142 27.2386 11 30 11Z",
    fill: "#EB5757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationFillIcon);
export default __webpack_public_path__ + "static/media/notification Fill Icon.acabd890e430b1a3863ec886d3103755.svg";
export { ForwardRef as ReactComponent };